import React from 'react';
import { Box, Inscription } from '@common-fe/common-fe';
import styled from 'styled-components';

import type { EligibleServiceCategory } from './hooks/useEligibleServicesFormatter';
import ServiceCategoryIcon from './ServiceCategoryIcon';

const Wrapper = styled(Box)`
  &:hover {
    background-color: ${({ theme }) => theme.colors.accentContainer};
    transition: all 0.3s ease-in-out;
  }
`;

interface Props {
  category: EligibleServiceCategory;
}

const EligibleServicesCategoryGroup: React.FC<Props> = ({ category }) => (
  <Box
    data-testid={`eligible-services-modal_category_${category?.category}`}
    gap="xxsmall"
  >
    <Box direction="row" gap="spacing4" align="center">
      <ServiceCategoryIcon
        type={category.categoryType}
        size="16px"
      />
      <Inscription
        data-testid={`eligible-services-modal_category_${category?.category}_name`}
        size="small"
        weight={500}
        color="textBody"
      >
        {category?.category || '-'}
      </Inscription>
    </Box>
    <Box
      round="container2Round"
      border={{ color: 'border1', size: 'xsmall' }}
      background="canvas"
    >
      {category?.services?.map((serviceName) => (
        <Wrapper
          key={serviceName}
          pad={{ vertical: 'spacing8', horizontal: 'spacing12' }}
          margin="spacing2"
          round="dropdownItemRound"
        >
          <Inscription size="medium" color="textBody">
            {serviceName}
          </Inscription>
        </Wrapper>
      ))}
    </Box>
  </Box>
);

export default EligibleServicesCategoryGroup;
